<ng-container>
  <div class="version">{{ version }}</div>

  <div class="coursefinder-container">
    <cf-header />

    <router-outlet />

    @if ((trendingCourses$ | async).length > 0) {
      <cf-trending-courses
        [courses]="trendingCourses$ | async"
        [isLoading]="isLoadingTrendingCourses" />
    }

    <!-- Mobile articles
      We want 'cf-trending-courses' to be displayed before the side content.
      We cannot therefore move the next section inside the layout component.
    -->
    @if (!isDesktop) {
      <div class="cf-articles">
        <cf-side-content />
      </div>
    }

    <cf-footer />
  </div>

  <accredible-cookies-banner />
</ng-container>
